import { Box, Typography } from "@mui/material";
import { WideButton } from "components/UI/CustomButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import classes from "./newsCard.module.scss";

const NewsCard = (props) => {
  const {
    variant = "flexCard",
    item = null,
    page = "news",
    button = false,
    titleLength = 80,
  } = props;

  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const navigate = useNavigate();

  const handleNavigate = () => {
    if (!page || !item?.slug) return;
    navigate(`/${page}/${item.slug}`);
  };

  const handleOpenFile = () => {
    if (file) window.open(file);
  };

  // Получение заголовка по текущему языку
  const getTitleByLang = () => {
    const localizedTitle = item?.[`title_${lang}`];
    if (localizedTitle && localizedTitle.trim()) return localizedTitle;
    if (item?.title_ky && item.title_ky.trim()) return item.title_ky;
    if (item?.title && item.title.trim()) return item.title;
    return "";
  };

  const getFileByLang = () => {
    return item?.[`file_${lang}`] ?? item?.file_ky ?? item?.file;
  };

  const title = getTitleByLang();
  const file = getFileByLang();

  const trimmedTitle =
    title?.length > titleLength ? title.slice(0, titleLength) + "..." : title;

  return (
    <Box className={classes[variant]}>
      <Box
        onClick={handleNavigate}
        className={classes.newsImg}
        component="img"
        src={item?.news_images?.[0]?.image ?? item?.image}
        alt={trimmedTitle}
      />
      <Box onClick={handleNavigate} className={classes.descNews}>
        <Typography className={classes.description}>{trimmedTitle}</Typography>
        {button && file && (
          <WideButton
            onClick={handleOpenFile}
            component="a"
            href={file}
            download
          >
            {t("download")}
          </WideButton>
        )}
      </Box>
    </Box>
  );
};

export default NewsCard;
